// @flow
// a couple of utility functions for games

export function checkIE(): boolean {
  // eslint-disable-next-line
  return /*@cc_on!@*/false || !!document.documentMode;
}

export function randomAudioPlayer(playlist: Array<String>): Audio {
  const url = playlist[Math.floor(Math.random() * playlist.length)];
  return new Audio(url);
}

export function shuffleArray<T>(array: Array<T>): Array<T> {
  const shuffledArray = array;

  for (let i = shuffledArray.length - 1; i > 0; i -= 1) {
    const randomIndex = Math.floor(Math.random() * (i + 1));

    [shuffledArray[i], shuffledArray[randomIndex]] = [
      shuffledArray[randomIndex],
      shuffledArray[i],
    ];
  }
  return shuffledArray;
}

export function updateArray<T>(array: Array<T>, index: number, value: T): Array<T> {
  return [...array.slice(0, index),
    value,
    ...array.slice(index + 1)];
}

export function randomInt(max: number): number {
  return Math.floor(Math.random() * Math.floor(max));
}
